import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { AlarmGroupEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class AlarmGroupSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    alarmGroupsUpdated$() {
        return this.socketService.receiveMessageObserver(AlarmGroupEvents.ALARM_GROUPS_UPDATED);
    }
}
